<template>
  <section class="w-full h-full p-4 box-border flex flex-col bg-white overflow-hidden" v-loading="pageLoading">
    <ul class="flex flex-wrap items-center pb-1">
      <li style="width: 300px;" class="mr-3 mb-3">
        <el-date-picker
          v-model="condition.dateRange"
          type="daterange"
          size="small"
          class="w-full-imp"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          clearable
        />
      </li>
      <li style="width: 160px;" class="mr-3 mb-3">
        <el-input v-model="condition.settleName" size="small" class="w-full-imp" placeholder="结算名称" clearable />
      </li>
      <li style="width: 160px;" class="mr-3 mb-3">
        <el-input v-model="condition.settleDept" size="small" class="w-full-imp" placeholder="部门" clearable />
      </li>
      <li style="width: 208px;" class="mb-3">
        <el-button type="primary" size="small" class="ml-0-imp mr-3" @click="queryList">查询</el-button>
        <el-button type="primary" size="small" plain class="ml-0-imp no-plainbtn-theme" @click="resetList">重置</el-button>
        <el-button type="text" size="small" :loading="exportLoading" v-if="exportLoading">导出</el-button>
        <el-dropdown class="ml-3" @command="exportHandle" v-else>
          <el-button type="text" size="small">导出</el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="PDF">导出PDF</el-dropdown-item>
            <el-dropdown-item command="Excel">导出Excel</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </li>
    </ul>
    <el-tabs class="header-tabs" v-model="activaTab" v-if="tabList.length > 0" @tab-click="changeTab">
      <el-tab-pane v-for="tb of tabList" :key="tb.tabKey" :name="tb.tabKey">
        <div slot="label">
          <div class="inline-block relative mr-1">
            <span>{{ tb.text }}</span>
            <div class="tab-dot mr-1 bg-danger inline-block top-2.5 -right-2.5 absolute" v-if="tb.noticeNum > 0" />
          </div>
          <span v-if="tb.noticeNum > 0">{{ tb.noticeNum }}</span>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div
      class="w-full pt-4 pb-2 box-border flex items-center justify-end text-medium text-theme-black-850 leading-22"
      v-if="list.length > 0"
    >
      结算项目
      <span class="text-medium font-semibold">&nbsp;{{ statistics.projectNum }}&nbsp;</span>
      个，结算总费用
      <span class="text-medium font-semibold">&nbsp;{{ statistics.operationalYuanAmount | formatPrice }}&nbsp;</span>
      元
    </div>
    <div class="pt-3" v-else />
    <div class="flex-1 overflow-hidden">
      <data-table
        ref="dataTable"
        class="sms_table w-full h-full overflow-hidden"
        cell-class-name="truncate-table-cell-wrap"
        align="left"
        :height="list.length > 0 ? 'calc(100% - 48px - 30px)' : 'calc(100% - 30px)'"
        :data="list"
        :loading="tableLoading"
        :columns="columns"
        :show-page="list.length > 0"
        :page="page"
        :show-tooltip="true"
        @size-change="changeSize"
        @pagination-current-change="changeNum"
        @row-click="checkReviewHandle"
      >
        <template #operationalYuanAmount="{ row }">
          <span>{{ row.operationalYuanAmount | formatPrice }}</span>
        </template>
        <template #status="{ row }">
          <span>{{ getStatus(row.status) }}</span>
        </template>
        <template #confirmPaidTime="{ row }">
          <span>{{ row.confirmPaidTime || '—' }}</span>
        </template>
        <template #action="{ row }">
          <el-button type="text" @click.stop="checkReviewHandle(row)">
            {{ isCheckView(row.status) ? '查看' : '去处理' }}
          </el-button>
        </template>
        <template #table-footer>
          <!-- 网站协议文案提示 -->
          <DygcFooter class="mt-2 -mb-2" />
        </template>
      </data-table>
    </div>
  </section>
</template>

<script>
import DataTable from '@/components/base/DataTable'
import { pageMixins } from '@/mixins/publish'
import { filtersMixins } from '@/mixins/relate-settlement'
import { getPageTabs } from '@/api/cost-settlement/common'
import { getUndertakes, downloadUndertakePDF, downloadUndertakeExcel } from '@/api/cost-settlement/undertake'
import { undertakeColumns, csCode, confirmStatusMap } from './config/undertake'
import DygcFooter from 'components/dygc-footer-bottom/index'

export default {
  name: 'Undertake',
  mixins: [pageMixins, filtersMixins],
  components: {
    DataTable,
    DygcFooter
  },
  data() {
    return {
      condition: {
        dateRange: [],
        settleName: '',
        settleDept: ''
      },
      activaTab: '',
      tabList: [],
      statistics: {
        projectNum: 0,
        operationalYuanAmount: 0
      },
      exportLoading: false,
      columns: undertakeColumns,
      list: [],
      tableLoading: false,
      pageLoading: false
    }
  },
  mounted() {
    this.getTabs()
  },
  methods: {
    isCheckView(status) {
      return status !== csCode.WAITPAID && status !== csCode.CONFIRMING
    },
    getStatus(status) {
      const statusText = confirmStatusMap[status]
      if (statusText) return statusText
      return '—'
    },
    // params: true获取tab数据 false只作为刷新数据
    getTabs(bool = true) {
      const parmas = this.getParams()
      delete parmas.settleDept
      const req = {
        ...parmas,
        tabKey: this.$route.meta.pageTabKey
      }
      if (bool) {
        this.pageLoading = true
      }
      getPageTabs(req)
        .then(res => {
          const data = res?.data?.data || []
          this.tabList = data
          if (bool) {
            if (data.length > 0) {
              this.activaTab = data[0].tabKey || ''
            }
            this.searchList()
          }
        })
        .catch(() => {
          this.$message.error('获取页签失败')
        })
        .finally(() => {
          if (bool) {
            this.pageLoading = false
          }
        })
    },
    getParams() {
      const { dateRange, settleName, settleDept } = this.condition
      const [createTimeStart, createTimeEnd] = dateRange || []
      const parmas = {
        descs: 'update_time'
      }
      if (createTimeStart) {
        parmas.createTimeStart = createTimeStart
      }
      if (createTimeEnd) {
        parmas.createTimeEnd = createTimeEnd
      }
      if (settleName) {
        parmas.settleName = settleName
      }
      if (settleDept) {
        parmas.settleDept = settleDept
      }
      return parmas
    },
    getList() {
      const { currentPage, pageSize } = this.page
      const parmas = {
        current: currentPage,
        size: pageSize,
        tabKey: +this.activaTab == 0 ? null : this.activaTab,
        ...this.getParams()
      }
      this.tableLoading = true
      getUndertakes(parmas)
        .then(res => {
          const { total, records, current, size, projectNum, operationalYuanAmount } = res?.data?.data || {}
          this.list = records || []
          this.page.total = total ?? 0
          this.page.currentPage = current
          this.page.pageSize = size
          this.statistics.projectNum = projectNum ?? 0
          this.statistics.operationalYuanAmount = operationalYuanAmount ?? 0
          this.$nextTick(()=>{
            this.$refs.dataTable.scrollTop()
          })
          this.$store.dispatch('refreshSettlementStatisticsAction')
        })
        .catch(() => {
          this.$message.error('获取我承接的项目列表失败')
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    queryList() {
      this.getTabs(false)
      this.searchList()
    },
    resetList() {
      this.condition.dateRange.splice(0)
      this.condition.settleName = ''
      this.condition.settleDept = ''
      this.queryList()
    },
    changeTab() {
      this.resetList()
    },
    exportExcel() {
      const params = this.getParams()
      const req = {
        tabKey: +this.activaTab == 0 ? null : this.activaTab,
        ...params
      }
      this.exportLoading = true
      downloadUndertakeExcel(req)
        .then(res => {
          const url = res?.data?.data
          if (url) {
            window.open(url)
          } else {
            this.$message.error('下载Excel失败')
          }
        })
        .catch(() => {
          this.$message.error('下载Excel失败')
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
    exportPDF() {
      const params = this.getParams()
      const req = {
        tabKey: +this.activaTab == 0 ? null : this.activaTab,
        ...params
      }
      this.exportLoading = true
      downloadUndertakePDF(req)
        .then(res => {
          const url = res?.data?.data
          if (url) {
            window.open(url)
          } else {
            this.$message.error('下载PDF失败')
          }
        })
        .catch(() => {
          this.$message.error('下载PDF失败')
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
    exportHandle(type) {
      if (!this.exportLoading) {
        if (type === 'PDF') {
          this.exportPDF()
        } else if (type === 'Excel') {
          this.exportExcel()
        }
      }
    },
    checkReviewHandle(item) {
      const routeURL = `settlement-undertake-detail/undertake-detail?investigatorStatementId=${item.id}&statementId=${item.statementId}&settleObjType=${item.settleObjType}&isEdit=false`
      window.open(`${window.location.origin + process.env.VUE_APP_PRE_URL}/#/${routeURL}`)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-range-editor--small .el-range-separator {
  width: auto;
}
</style>